import { IHistoryManager } from "./AdminHistory/IHistoryManager";
import { IAdvertProvider } from "./Adverts/IAdvertProvider";
import { IAddressValidator } from "./Authentication/IAddressValidator";
import { IApiKeyValidator } from "./Authentication/IApiKeyValidator";
import { IAuthenticator } from "./Authentication/IAuthenticator";
import { IAnalyticProcessor } from "./Analytics/IAnalyticProcessor";
import { IDataLogger } from "./Logging/IDataLogger";
import { IEventTrigger } from "./Events/IEventTrigger";
import { ILookupService } from "./Lookup/ILookupService";
import { ICommunicationsSender } from "./Communications/ICommunicationsSender";
import { IEmailService } from "./Communications/IEmailService";
import { IPushService } from "./Communications/IPushService";
import { IWebhookService } from "./Communications/IWebhookService";
import { ISmsService } from "./Communications/ISmsService";
import { IRelationshipService } from "./Relationships/IRelationshipService";
import { ISequencer } from "./Sequences/ISequencer";
import { ISessionProvider } from "./Sessions/ISessionProvider";
import { ITaskCreator } from "./Tasks/ITaskCreator";
import { IUserContext } from "./IUserContext";
import { ICaptchaService } from "./Throttling/ICaptchaService";
import { ICountryLookup } from "./Throttling/ICountryLookup";
import { IRestrictionManager } from "./Throttling/IRestrictionManager";
import { IThrottler } from "./Throttling/IThrottler";
import { IGeocoder } from "./Geocoding/IGeocoder";

export default function (context: IUserContext): void {
    context.registerService({
        name: 'IHistoryManager',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-history-manager" */ './AdminHistory/HistoryManager')
                .then((svc) => {
                    return new svc.HistoryManager(context) as IHistoryManager;
                });
        }
    });

    context.registerService({
        name: 'IAdvertProvider',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-advert-provider" */ './Adverts/AdvertProvider')
                .then((svc) => {
                    return new svc.AdvertProvider(context) as IAdvertProvider;
                });
        }
    });

    context.registerService({
        name: 'IAnalyticProcessor',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-analytic-processor" */ './Analytics/AnalyticProcessor')
                .then((svc) => {
                    return new svc.AnalyticProcessor(context) as IAnalyticProcessor;
                });
        }
    });

    context.registerService({
        name: 'IAddressValidator',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-address-validator" */ './Authentication/AddressValidator')
                .then((svc) => {
                    return new svc.AddressValidator(context) as IAddressValidator;
                });
        }
    });

     context.registerService({
        name: 'IApiKeyValidator',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-apikey-validator" */ './Authentication/ApiKeyValidator')
                .then((svc) => {
                    return new svc.ApiKeyValidator(context) as IApiKeyValidator;
                });
        }
    });

    context.registerService({
        name: 'IAuthenticator',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-authenticator" */ './Authentication/Authenticator')
                .then((svc) => {
                    return new svc.Authenticator(context) as IAuthenticator;
                });
        }
    });

    context.registerService({
        name: 'IDataLogger',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-data-logger" */ './Logging/DataLogger')
                .then((svc) => {
                    return new svc.DataLogger(context) as IDataLogger;
                });
        }
    });

    context.registerService({
        name: 'IEventTrigger',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-event-trigger" */ './Events/EventTrigger')
                .then((svc) => {
                    return new svc.EventTrigger(context) as IEventTrigger;
                });
        }
    });

    context.registerService({
        name: 'IGeocoder',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-geocoder" */ './Geocoding/Geocoder')
                .then((svc) => {
                    return new svc.Geocoder(context) as IGeocoder;
                });
        }
    });

    context.registerService({
        name: 'IRelationshipService',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-relationship-service" */ './Relationships/RelationshipService')
                .then((svc) => {
                    return new svc.RelationshipService(context) as IRelationshipService;
                });
        }
    });

    context.registerService({
        name: 'ISequencer',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-sequencer" */ './Sequences/Sequencer')
                .then((svc) => {
                    return new svc.Sequencer(context) as ISequencer;
                });
        }
    });

    context.registerService({
        name: 'ISessionProvider',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-session-provider" */ './Sessions/SessionProvider')
                .then((svc) => {
                    return new svc.SessionProvider(context) as ISessionProvider;
                });
        }
    });

    context.registerService({
        name: 'ILookupService',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-lookup-service" */ './Lookup/LookupService')
                .then((svc) => {
                    return new svc.LookupService(context) as ILookupService;
                });
        }
    });

    context.registerService({
        name: 'ICommunicationsSender',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-communications-sender" */ './Communications/CommunicationsSender')
                .then((svc) => {
                    return new svc.CommunicationsSender(context) as ICommunicationsSender;
                });
        }
    });

    context.registerService({
        name: 'IPushService',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-push-service" */ './Communications/PushService')
                .then((svc) => {
                    return new svc.PushService(context) as IPushService;
                });
        }
    });

    context.registerService({
        name: 'IEmailService',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-email-service" */ './Communications/EmailService')
                .then((svc) => {
                    return new svc.EmailService(context) as IEmailService;
                });
        }
    });

    context.registerService({
        name: 'IWebhookService',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-webhook-service" */ './Communications/WebhookService')
                .then((svc) => {
                    return new svc.WebhookService(context) as IWebhookService;
                });
        }
    });

    context.registerService({
        name: 'ISmsService',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-sms-service" */ './Communications/SmsService')
                .then((svc) => {
                    return new svc.SmsService(context) as ISmsService;
                });
        }
    });

    context.registerService({
        name: 'ITaskCreator',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-task-creator" */ './Tasks/TaskCreator')
                .then((svc) => {
                    return new svc.TaskCreator(context) as ITaskCreator;
                });
        }
    });

    context.registerService({
        name: 'ICaptchaService',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-captcha-service" */ './Throttling/CaptchaService')
                .then((svc) => {
                    return new svc.CaptchaService(context) as ICaptchaService;
                });
        }
    });

    context.registerService({
        name: 'ICountryLookup',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-country-lookup" */ './Throttling/CountryLookup')
                .then((svc) => {
                    return new svc.CountryLookup(context) as ICountryLookup;
                });
        }
    });

    context.registerService({
        name: 'IRestrictionManager',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-restriction-manager" */ './Throttling/RestrictionManager')
                .then((svc) => {
                    return new svc.RestrictionManager(context) as IRestrictionManager;
                });
        }
    });

    context.registerService({
        name: 'IThrottler',
        activator: () => {
            return import(/* webpackChunkName: "api-systems-throttler" */ './Throttling/Throttler')
                .then((svc) => {
                    return new svc.Throttler(context) as IThrottler;
                });
        }
    });
}
